import { useCallback, useState } from "react";
import { getEGiftCardStatistics } from "../api/eGiftCard.api";
import type { EGiftCardStatisticsResponse } from "../types/eGiftCard.types";

export const useEGiftCardStatistics = () => {
  const [statistics, setStatistics] = useState<EGiftCardStatisticsResponse | null>(null);

  const refreshStatistics = useCallback(async () => {
    try {
      const result = await getEGiftCardStatistics();
      setStatistics(result);
      return result;
    } catch (error) {
      console.error("Failed to fetch reward summary:", error);
      return null;
    }
  }, []);

  return { statistics, refreshStatistics };
};
